const ColorPalette = {
  primary: '#0BB4E7',
  primaryBackground: 'rgba(11, 180, 231, 0.1)',
  iconLight: '#140034',
  iconDark: '#E7E5EA',
  white: '#FFFFFF',
  textWhite: '#E7E5EA',
  textDark: '#140034',
  activeBg: 'rgba(244, 182, 58, 0.3)',
  active: '#F4B63A',
  purple: '#611CAF',
  iconBg: `rgba(231, 229, 234, 0.5)`,
  error: '#FF6B6B',
};
export default ColorPalette;
